import { useState } from 'react';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const slides = [
  {
    image: 'https://images.unsplash.com/photo-1521017432531-fbd92d768814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxMDY4NDc1fDA&ixlib=rb-4.1.0&q=85',
    title: 'Freshly Brewed Tea',
    subtitle: 'Delicious Tea & Snacks',
    description: 'Best Tea Spot in Nagercoil'
  },
  {
    image: 'https://images.unsplash.com/photo-1529006557810-274b9b2fc783?w=1600&auto=format&fit=crop&q=80',
    title: 'Premium Shawarma',
    subtitle: 'Mouth-watering Flavors',
    description: 'From Classic to Peri Peri'
  },
  {
    image: 'https://images.unsplash.com/photo-1653542772393-71ffa417b1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2ppdG98ZW58MHx8fHwxNzcxMDY4NTI5fDA&ixlib=rb-4.1.0&q=85',
    title: 'Refreshing Mojitos',
    subtitle: 'Cool & Colorful',
    description: 'Perfect for Every Mood'
  }
];

export const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-[500px] sm:h-[600px] lg:h-[700px] overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
        >
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          />

          {/* Overlay */}
          <div className="absolute inset-0 hero-overlay" />

          {/* Content */}
          <div className="relative h-full flex items-center">
            <div className="section-container">
              <div className="max-w-2xl text-primary-foreground">
                <p className="text-sm sm:text-base font-medium mb-2 sm:mb-4 text-secondary">
                  {slide.subtitle}
                </p>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold mb-3 sm:mb-4 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-lg sm:text-xl lg:text-2xl mb-6 sm:mb-8 text-primary-foreground/90">
                  {slide.description}
                </p>
                <div className="flex flex-wrap gap-4">
                  <Link to="/menu">
                    <Button size="lg" className="btn-primary text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6">
                      SHOP NOW
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Button>
                  </Link>
                  <Link to="/book-seat">
                    <Button size="lg" variant="outline" className="text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 bg-primary-foreground/10 border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/20">
                      BOOK A SEAT
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-primary-foreground/20 hover:bg-primary-foreground/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-colors z-10"
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-6 h-6 text-primary-foreground" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-primary-foreground/20 hover:bg-primary-foreground/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-colors z-10"
        aria-label="Next slide"
      >
        <ChevronRight className="w-6 h-6 text-primary-foreground" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all ${index === currentSlide
                ? 'bg-secondary w-8'
                : 'bg-primary-foreground/50 hover:bg-primary-foreground/70'
              }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;